import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as propertyHooks from "@rentiohq/shared-frontend/dist/reduxV2/property/property.hooks";
import { Loading } from "../Loading";
export var PropertyFetchListItem = function (props) {
    var property = props.property, propertyId = props.propertyId, renderProperty = props.renderProperty, shouldRefetch = props.shouldRefetch;
    var _a = propertyHooks.useDetail({
        shouldRefetch: shouldRefetch,
        id: propertyId,
    }), fetchedProperty = _a.detail, isFetching = _a.isFetching;
    if (property) {
        return _jsx(_Fragment, { children: renderProperty(property) });
    }
    if (isFetching) {
        return _jsx(Loading, { asDots: true });
    }
    if (fetchedProperty) {
        return _jsx(_Fragment, { children: renderProperty(fetchedProperty) });
    }
    return null;
};
